"use strict";
exports.__esModule = true;
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var logic_1 = require("./logic");
var currency = (0, currencies_1.getCryptoCurrencyById)("polkadot");
var getSendFields = function (_a) {
    var transaction = _a.transaction, amount = _a.status.amount;
    var fields = [];
    fields.push({
        type: "text",
        label: "Balances",
        value: transaction && transaction.useAllAmount
            ? "Transfer"
            : "Transfer keep alive"
    });
    fields.push({
        type: "text",
        label: "Amount",
        value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], amount, {
            showCode: true,
            disableRounding: true
        })
    });
    return fields;
};
function getDeviceTransactionConfig(_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction, status = _a.status;
    var mode = transaction.mode, recipient = transaction.recipient, rewardDestination = transaction.rewardDestination;
    var amount = status.amount;
    var mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    var fields = [];
    switch (mode) {
        case "send":
            fields = getSendFields({
                transaction: transaction,
                status: status
            });
            break;
        case "nominate":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Nominate"
            });
            fields.push({
                type: "polkadot.validators",
                label: "Targets"
            });
            break;
        case "bond":
            if (!(0, logic_1.isStash)(mainAccount)) {
                fields.push({
                    type: "text",
                    label: "Staking",
                    value: "Bond"
                });
                fields.push({
                    type: "text",
                    label: "Controller",
                    value: recipient
                });
                fields.push({
                    type: "text",
                    label: "Amount",
                    value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], amount, {
                        showCode: true,
                        disableRounding: true
                    })
                });
                fields.push({
                    type: "text",
                    label: "Payee",
                    value: rewardDestination || "Stash"
                });
            }
            else {
                fields.push({
                    type: "text",
                    label: "Staking",
                    value: "Bond extra"
                });
                fields.push({
                    type: "text",
                    label: "Amount",
                    value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], amount, {
                        showCode: true,
                        disableRounding: true
                    })
                });
            }
            break;
        case "rebond":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Rebond"
            });
            fields.push({
                type: "text",
                label: "Amount",
                value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], amount, {
                    showCode: true,
                    disableRounding: true
                })
            });
            break;
        case "unbond":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Unbond"
            });
            fields.push({
                type: "text",
                label: "Amount",
                value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], amount, {
                    showCode: true,
                    disableRounding: true
                })
            });
            break;
        case "chill":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Chill"
            });
            break;
        case "withdrawUnbonded":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Withdraw Unbonded"
            });
            break;
        case "setController":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Set controller"
            });
            fields.push({
                type: "text",
                label: "Controller",
                value: 
                // NOTE: I added this here as TokenAccount and ChildAccount
                // both don't have freshAddress
                account.type === "Account"
                    ? account.freshAddress
                    : mainAccount.freshAddress
            });
            break;
        case "claimReward":
            fields.push({
                type: "text",
                label: "Staking",
                value: "Payout Stakers"
            });
            break;
        default:
            break;
    }
    fields.push({
        type: "fees",
        label: "Fees"
    });
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map